<template>
    <div
        :class="size"
        class="round my-1 bg-primary text-white d-flex justify-content-center align-items-center"
        v-tooltip="name"
    >
        <img
            v-if="url && !url.includes('default_')"
            :class="size"
            class="round"
            :src="url"
            :alt="initials"
        />
        <span v-else="" class="text-uppercase">{{ initials }}</span>
    </div>
</template>

<script>
export default {
    name: "ProfilePicture",
    props: ["url", "size", "square", "name"],
    computed: {
        initials() {
            let initials = "";
            if (this.name) {
                this.name.split(" ").forEach(n => (initials += n.split("")[0]));
            }
            if (initials.length > 2) {
                initials = initials[0] + initials[initials.length - 1];
            }
            return initials;
        },
    },
};
</script>

<style scoped>
.sm {
    min-height: 1.5rem;
    min-width: 1.5rem;
    max-height: 1.5rem;
    max-width: 1.5rem;
    font-size: 1rem;
}

.md {
    min-height: 2.5rem;
    min-width: 2.5rem;
    max-height: 2.5rem;
    max-width: 2.5rem;
    font-size: 2rem;
}

.lg {
    min-height: 3.5rem;
    min-width: 3.5rem;
    max-height: 3.5rem;
    max-width: 3.5rem;
    font-size: 3rem;
}

.round {
    border-radius: 50%;
}
</style>
